import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe } from '@angular/common';

import { environment } from "../../../../../environments/environment";

import { CmsService } from 'src/app/Services/cms.service';

@Component({
  selector: 'app-noticias-detalhe',
  templateUrl: './noticias-detalhe.component.html',
  standalone: false
})
export class NoticiasDetalheComponent implements OnInit{
  language: string = '';
  defaultLanguage: string = environment.defaultLanguage;
  content_name: string = 'linhas-news-list';

  newsReady: number = 0;

  newsId: string = '';
  newsDetail: any = {}
  formattedDate: string = '';

  newsRelated: any[] = []
  newsRelatedSize: number = 0;

  currentUrl: string = encodeURIComponent(window.location.href);
  currentTitle: string = encodeURIComponent(document.title);

  socialLinks = {
    facebook: ``,
    twitter: ``,
    whatsapp: ``,
    linkedin: ``,
  };

  constructor(
    private cmsService: CmsService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private meta: Meta,
    private datePipe: DatePipe,
    private translate: TranslateService,
    private title: Title
    ) {
      let lang = localStorage.getItem('language') ?? this.defaultLanguage;
      this.language = lang.split('-')[0];

      this.translate.get('navLinks').pipe().subscribe(trans => {
        let pageTitle =  trans['linhas'] + ' | ' + trans['noticias']
        this.title.setTitle(pageTitle);
      })
    }

    ngOnInit() {
      this.newsDetail = {}
      this.activatedRoute.queryParams
      .subscribe(queryParams => {
        queryParams['id'] != undefined ? this.newsId = queryParams['id'] : this.back();
      })
      this.getNews()
    }

    getNews(){
      this.newsReady = 0;
      this.cmsService.getContent(this.content_name, this.newsId, this.language).subscribe(
        {
          next: data => {
            this.newsDetail = data['body']['data'];
            this.newsRelated = data['body']['data']['Relacionadas']
            this.newsRelatedSize = this.newsRelated.length

            this.newsRelated.forEach(element => {
              let date = new Date(element.Data)
              element.formattedDate = Intl.DateTimeFormat(this.language, { day: 'numeric', month: 'long', year: 'numeric' }).format(date);
            });

            this.meta.updateTag({ property: 'og:title', content: this.newsDetail.Titulo });
            this.meta.updateTag({ property: 'og:description', content: this.newsDetail.Titulo });
            this.meta.updateTag({ property: 'og:image', content: this.newsDetail.Imagem.url });
            this.meta.updateTag({ property: 'og:url', content: this.currentUrl });

            let date = new Date(this.newsDetail.Data)
            this.formattedDate = Intl.DateTimeFormat(this.language, { day: 'numeric', month: 'long', year: 'numeric' }).format(date);

            this.socialLinks = {
              facebook: `https://www.facebook.com/sharer/sharer.php?u=${this.currentUrl}`,
              twitter: `https://x.com/intent/tweet?url=${this.currentUrl}&text=${this.newsDetail.Titulo}`,
              whatsapp: `https://wa.me/?text=${this.newsDetail.Titulo} - ${this.currentUrl}`,
              linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${this.currentUrl}`,
            };

            this.newsReady = 1;

          },
          error: er => {
            this.back()
            //this.router.navigate(['/500']);
          }
        }
      );
    }

    goToNews(id: string){
      this.newsId = id
      this.getNews();
    }

    back(){
      this.router.navigate(['/noticias']);
    }

  copyToClipboard(event: Event): void {
    event.preventDefault();
    navigator.clipboard.writeText(window.location.href).then(() => {
      alert('Link copiado para a área de transferência!');
    }).catch(err => {
      console.error('Erro ao copiar link: ', err);
    });
  }

}
